export function Divider() {
  return (
    <div
      role="separator"
      className="border-solid border-color-gray-400 border-bottom-s"
    />
  );
}
